import { CartEntryErrorEffect } from './cart-entry-error.effect';
import { GlobalMessageEffect } from './global-message.effect';

export const effects: any[] = [GlobalMessageEffect, CartEntryErrorEffect];
